import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import InvoiceView from './InvoiceView';
import { arSummaryActions } from 'src/store/modules/arSummary';
import InvoiceModel from 'src/model/invoice.model';
import { IInitialState } from 'src/store/initialState';

import { regionSel, localeActions } from 'src/store/modules/locale';

import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';

import {
  dataSel,
  statusFilterSel,
  datesFilterSel,
  sortFilterSel,
  pageNumberSel,
  pageSizeSel,
  totalPagesSel,
  getInvoicesIsPendingSel,
  invoicesActions,
  selectedInvoicesSel,
  isInvoiceActiveSel
} from 'src/store/modules/invoices';

import {
  accountsSel,
  accountsIsPendingSel,
  userActions
} from 'src/store/modules/user';

const mapStateToProps = (state: IInitialState) => ({
  userAccounts: accountsSel(state),
  userAccountsIsPending: accountsIsPendingSel(state),
  invoiceContent: dataSel(state),
  getInvoicesIsPending: getInvoicesIsPendingSel(state),
  datesFilter: datesFilterSel(state),
  statusFilter: statusFilterSel(state),
  sortFilter: sortFilterSel(state),
  pagination: {
    pageNumber: pageNumberSel(state),
    pageSize: pageSizeSel(state),
    totalPages: totalPagesSel(state)
  },
  region: regionSel(state),
  selectedInvoices: selectedInvoicesSel(state),
  isInvoiceActive: isInvoiceActiveSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  getUserAccounts: () => dispatch(userActions.getUserAccounts()),
  setRegion: (region: string) => dispatch(localeActions.setRegion(region)),
  getInvoices: (filters: IFiltersInvoice, pagination: IPaginationInvoice) =>
    dispatch(invoicesActions.getInvoices(filters, pagination)),
  getArSummary: () => {
    dispatch(arSummaryActions.getArSummary());
  },
  addSelectedInvoices: (invoices: InvoiceModel | InvoiceModel[]) =>
    dispatch(invoicesActions.addSelectedInvoices(invoices)),
  removeInvoiceFromSelected: (invoice: InvoiceModel) =>
    dispatch(invoicesActions.removeInvoiceFromSelected(invoice)),
  clearSelectedInvoices: () => dispatch(invoicesActions.clearSelectedInvoices())
});

export const pureComponent = InvoiceView;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(InvoiceView));
